// Cosmetic display scaling for ratings.
//
// Internal storage stays on raw OpenSkill values: μ, σ in DB
// (default μ=25, σ≈8.33). The displayed value is raw μ scaled and
// offset for a chess-Elo-shaped feel. Confidence (σ) is shown
// separately via the Gaussian primitive — the displayed number
// doesn't try to encode it.
//
// Anchors:
//   μ = 25 (default new player) → 500 (middle of the 0–1000 scale)
//   μ = 5  (≈ −2.4σ_init below)  → 0   (effectively unreachable)
//   μ = 45 (≈ +2.4σ_init above)  → 1000 (effectively unreachable)
//
// Friend-group cluster (μ ~ 22–28) lands roughly 425–575 in display SR,
// with stronger players reaching 600–700 and outliers touching 300/750.

export const RATING_DISPLAY_SCALE = 25
export const RATING_DISPLAY_OFFSET = -125

// Convert raw μ to the display-facing rating number.
export const scaledRating = (rawMu: number): number =>
  Math.round(rawMu * RATING_DISPLAY_SCALE + RATING_DISPLAY_OFFSET)

// Per-play "+SR" deltas. Offset cancels in subtraction so this is just
// the raw Δμ times the scale.
export const scaledDelta = (rawDelta: number): number => Math.round(rawDelta * RATING_DISPLAY_SCALE)
